import React from "react";
import styled from "styled-components";

import { quickblue } from "../theme/Colors";

const Wrapper = styled.address``;

const Name = styled.h5`
	margin: 15px 0 5px 0;
	margin: 0;
	margin-top: 15px;
	font-family: "Cera Basic";
	font-size: 1.15em;
	color: ${quickblue};
`;

const Address = styled.p`
	margin: 0;
`;

const Website = styled.a`
	color: #01788a;
	font-size: 15px;
	text-decoration: underline;
`;

const Contact = ({ name, street, city, state, zip, url, ...props }) => (
	<Wrapper {...props}>
		<h5 className="TGh7">{name}</h5>
		<address className="TGaddress2">
			{street}, {city}, {state} {zip}
		</address>
		<Website href={url}>Website</Website>
	</Wrapper>
);

export default Contact;
